module.exports = __webpack_public_path__ + "img/the-netherlands-respiratory-diseases-male.7b1548eb.png";